(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["filter"] && !Shopify.designMode) return;
  try {
    // Simple keyboard handler for filter toggles
  document.addEventListener('keydown', function(e) {
    const toggle = e.target;
    
    // Check if focused element is a filter toggle
    if (toggle.classList && toggle.classList.contains('filter--toggle')) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        
        // Toggle aria-expanded
        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', !isExpanded);
        
        // Also try to click it so theme.js handlers work
        try {
          toggle.click();
        } catch(err) {
          console.log('Click failed, but aria-expanded toggled');
        }
      }
    }
  }, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-quick-add"] && !Shopify.designMode) return;
  try {
    // Manage tabindex for hover-mode quick-add buttons
  // When button is hidden (opacity: 0, scale: 0), it should not be in tab order
  // When button becomes visible (on hover/focus), allow it to be tabbed to
  document.querySelectorAll('[data-hover="true"] .product-quick-add--button[tabindex="-1"]').forEach(button => {
    const quickAdd = button.closest('.product-quick-add');
    const parentCard = quickAdd.closest('[class*="product-card"]');
    
    if (!quickAdd || !parentCard) return;
    
    const makeButtonFocusable = () => {
      button.removeAttribute('tabindex');
    };
    
    const makeButtonUnfocusable = () => {
      if (document.activeElement !== button) {
        button.setAttribute('tabindex', '-1');
      }
    };
    
    // Show/hide tabindex on hover
    parentCard.addEventListener('mouseenter', makeButtonFocusable);
    parentCard.addEventListener('mouseleave', makeButtonUnfocusable);
    
    // Show tabindex when button gets focus
    button.addEventListener('focus', makeButtonFocusable);
    
    // Hide tabindex when button loses focus (and is not hovering)
    button.addEventListener('blur', (e) => {
      // Use a small timeout to let mouseenter/mouseleave fire first
      setTimeout(() => {
        if (!parentCard.matches(':hover')) {
          makeButtonUnfocusable();
        }
      }, 10);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
